import * as React from "react"

export function LocationIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" {...props}>
      <path d="M513.3 985.4c-3.9 3.1-8.6 4.6-13.3 4.6-4.7 0-9.4-1.5-13.3-4.6-14.5-11.4-354.4-325.9-354.4-607.9C132.3 174.9 297.3 10 500 10s367.7 164.9 367.7 367.5c0 282-339.9 596.5-354.4 607.9zM500 205.9c-94.8 0-171.6 76.8-171.6 171.6S405.2 549.1 500 549.1s171.6-76.8 171.6-171.6S594.8 205.9 500 205.9z" />
    </svg>
  )
}
